import { render, staticRenderFns } from "./HeaderTemplatePage.vue?vue&type=template&id=b0ded21e&"
import script from "./HeaderTemplatePage.vue?vue&type=script&lang=js&"
export * from "./HeaderTemplatePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports